import { auth } from '@/firebase';
const URL = 'https://faas-nyc1-2ef2e6cc.doserverless.co/api/v1/web/fn-12f47b02-5e16-417c-b4e1-1566a1d5fe44/v1/permissions';

class Roles {
    static async get(path='', token=null) {
        const response = await fetch(`${URL}${path}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token || await auth.currentUser.getIdToken()}`,
            },
        });
        return await response.json();
    }

    static async post(path='', body, token=null) {
        const response = await fetch(`${URL}${path}`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token || await auth.currentUser.getIdToken()}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        });

        return await response.json();
    }

    static async put(path='', body, token=null) {
        const response = await fetch(`${URL}${path}`, {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${token || await auth.currentUser.getIdToken()}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        });

        return await response.json();
    }

    static async delete(path='', token=null) {
        const response = await fetch(`${URL}${path}`, {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${token || await auth.currentUser.getIdToken()}`,
            },
        });

        return await response.json();
    }
}

export default Roles;